import React from 'react';
import { bool, string } from 'prop-types';
import classNames from 'classnames';

import css from './SectionReviewSummary.module.css';
import { FormattedMessage } from 'react-intl';

const SectionReviewSummary = props => {
  const { reviews } = props;

  const positiveNo = reviews ? reviews.filter(r => r.attributes.rating >= 4)?.length : "-";
  const neutralNo = reviews ? reviews.filter(r => r.attributes.rating === 3)?.length : "-";
  const negativeNo = reviews ? reviews.filter(r => r.attributes.rating <= 2)?.length : "-";

  const ratingsSum = reviews?.reduce((total, review) => total + review.attributes.rating, 0);
  const averageScore = reviews && ratingsSum ? ratingsSum / reviews.length : '-';

  const averageScoreContainerCss = averageScore >= 4 ? css.containerTotalPositive : averageScore === 3 ? css.containerTotalNeutral : css.containerTotalNegative;
  const averageScoreLabelCss = averageScore >= 4 ? css.labelPositive : averageScore === 3 ? css.labelNeutral : css.labelNegative;

  return (
    <div>
      <h3>
        <FormattedMessage id="SectionReviewSummary.title" />
      </h3>

      <div className={css.root}>

        <div className={css.containerBase}>
          <div className={averageScoreContainerCss}>
            {averageScore}
          </div>
          <p className={averageScoreLabelCss}>
            <FormattedMessage id="SectionReviewSummary.yourAverageScore" />
          </p>
        </div>

        <div className={css.containerBase}>
          <div className={css.containerNegative}>
            {negativeNo}
          </div>

          <p className={css.labelNegative}>
            <FormattedMessage id="SectionReviewSummary.negative" />
          </p>
        </div>

        <div className={css.containerBase}>
          <div className={css.containerNeutral}>
            {neutralNo}
          </div>
          <p className={css.labelNeutral}>
            <FormattedMessage id="SectionReviewSummary.neutral" />
          </p>
        </div>

        <div className={css.containerBase}>
          <div className={css.containerPositive}>
            {positiveNo}
          </div>
          <p className={css.labelPositive}>
            <FormattedMessage id="SectionReviewSummary.positive" />
          </p>
        </div>

      </div>
    </div>
  );
};

SectionReviewSummary.defaultProps = {
};

SectionReviewSummary.propTypes = {
};

export default SectionReviewSummary;
